import { Component, Input } from '@angular/core';

import { TranslatePipe } from '../../../core/i18n/translate.pipe';
import { StatusBadgeTone } from './status-badge.models';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <span class="status-badge" [class]="toneClass">
      {{ label | t }}
    </span>
  `,
  styles: [`
    .status-badge {
      display: inline-flex;
      align-items: center;
      min-height: 28px;
      padding: 0 10px;
      border-radius: 999px;
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
    }

    .status-badge--neutral {
      background: #e5e7eb;
      color: #374151;
    }

    .status-badge--success {
      background: #dcfce7;
      color: #166534;
    }

    .status-badge--warning {
      background: #fef3c7;
      color: #92400e;
    }

    .status-badge--danger {
      background: #fee2e2;
      color: #991b1b;
    }

    .status-badge--info {
      background: #dbeafe;
      color: #1d4ed8;
    }
  `]
})
export class StatusBadgeComponent
{
  @Input()
  public label = '';

  @Input()
  public tone: StatusBadgeTone = 'neutral';

  protected get toneClass(): string
  {
    return `status-badge--${this.tone}`;
  }
}
